// ABOUTME: Generic string manipulation helpers shared across the UI.
// ABOUTME: Provides capitalize and toTitleCase implemented in plain JS.

export const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

export const toTitleCase = (str: string) => str.split(/\s+/).map(capitalize).join(' ');
